import {
    faArrowsUpDown,
    faCakeCandles,
    faCat,
    faCheck,
    faDog,
    faEye,
    faHeart,
    faHouse,
    faLocationDot,
    faMagnifyingGlass,
    faMars,
    faPalette,
    faPaw,
    faShieldDog,
    faSyringe,
    faUser,
    faVenus,
    faVenusMars,
    faXmark,
    faFilter
} from "@fortawesome/free-solid-svg-icons";


export const ANIMAL_LIST_CONF = {
    ELEMENTS_PER_ROW_DESKTOP: 3,
    ELEMENTS_PER_PAGE_DESKTOP: 12,
    ELEMENTS_PER_ROW_TABLET: 2,
    ELEMENTS_PER_PAGE_TABLET: 12,
    ELEMENTS_PER_ROW_MOBILE: 1,
    ELEMENTS_PER_PAGE_MOBILE: 12,
}

export const ANIMAL_LIST_RECOMMENDATIONS_CONF = {
    ELEMENTS_PER_ROW_DESKTOP: 3,
    ELEMENTS_PER_PAGE_DESKTOP: 3,
    ELEMENTS_PER_ROW_TABLET: 2,
    ELEMENTS_PER_PAGE_TABLET: 4,
    ELEMENTS_PER_ROW_MOBILE: 1,
    ELEMENTS_PER_PAGE_MOBILE: 3,
}
export const MAX_NUM_ANIMALES_PARTICULARES= 3


export const ICON_SCALE_FILTER = 0.055;
export const ICON_SCALE_DEFAULT = 0.05;
export const ICON_SCALE_MOBILE = 0.04;
export const ICON_SCALE_USER = 0.035;

export const MAP_PROPS_ANIMAL_CONFIG = {
    especie: {
        perro: {
            nameProp: "perro",
            value: "perro",
            label: "Perro",
            longLabel: "Perro",
            faIcon: faDog,
            colorIcon: "#000",
            scale: ICON_SCALE_DEFAULT,
            scaleMobile: ICON_SCALE_MOBILE,
        },
        "default": {
            nameProp: "default",
            value: "ambos",
            label: "Ambos",
            longLabel: "Ambos",
            faIcon: faPaw,
            colorIcon: "#000",
            scale: ICON_SCALE_DEFAULT,
            scaleMobile: ICON_SCALE_MOBILE,
        },
        gato: {
            nameProp: "gato",
            value: "gato",
            label: "Gato",
            longLabel: "Gato",
            faIcon: faCat,
            colorIcon: "#000",
            scale: ICON_SCALE_DEFAULT,
            scaleMobile: ICON_SCALE_MOBILE,
        }
    },
    raza: {
        "default": {
            nameProp: "default",
            value: "all",
            label: "TODAS",
            longLabel: "TODAS",
            faIcon: faPaw,
            maxLimit: 3,
        }
    },
    sexo: {
        hembra: {
            nameProp: "hembra",
            value: "hembra",
            label: "Hembra",
            longLabel: "Hembra",
            faIcon: faVenus,
            colorIcon: "#000",
            scale: ICON_SCALE_DEFAULT,
            scaleMobile: ICON_SCALE_MOBILE,
        },
        "default": {
            nameProp: "default",
            value: "ambos",
            label: "Ambos",
            longLabel: "Ambos",
            faIcon: faVenusMars,
            colorIcon: "#000",
            scale: ICON_SCALE_DEFAULT,
            scaleMobile: ICON_SCALE_MOBILE,
        },
        macho: {
            nameProp: "macho",
            value: "macho",
            label: "Macho",
            longLabel: "Macho",
            faIcon: faMars,
            colorIcon: "#000",
            scale: ICON_SCALE_DEFAULT,
            scaleMobile: ICON_SCALE_MOBILE,
        }
    },
    edad: {
        "default": {
            nameProp: "default",
            value: [],
            label: "Todas",
            longLabel: "Todas",
            faIcon: faCakeCandles,
            colorIcon: "#ff9083",
            scale: ICON_SCALE_DEFAULT,
            scaleMobile: ICON_SCALE_MOBILE,
        },
        cachorro: {
            nameProp: "cachorro",
            value: "cachorro",
            label: "Cachorro",
            longLabel: "Cachorro",
            perro: {info: "Menos de 12 meses"},
            gato: {info: "Menos de 6 meses"},
        },
        joven: {
            nameProp: "joven",
            value: "joven",
            label: "Joven",
            longLabel: "Joven",
            perro: {info: "De 1 años a 4 años"},
            gato: {info: "De 7 meses a 2 años"},
        },
        adulto: {
            nameProp: "adulto",
            value: "adulto",
            label: "Adulto",
            longLabel: "Adulto",
            perro: {info: "De 4 a 8 años"},
            gato: {info: "De 3 a 9 años"},
        },

        mayor: {
            nameProp: "mayor",
            value: "mayor",
            label: "Mayor",
            longLabel: "Mayor",
            perro: {info: "De 8 a 12 años"},
            gato: {info: "De 10 a 14 años"},
        },

        abuelo: {
            nameProp: "abuelo",
            value: "abuelo",
            label: "Abuelo",
            longLabel: "Abuelo",
            perro: {info: "Más de 12 años"},
            gato: {info: "Más de 15 años"},
        },
    },
    tamano: {
        "default": {
            nameProp: "default",
            label: "Todos",
            longLabel: "Todos",
            value: [],
            faIcon: faArrowsUpDown,
            // faIcon: faRulerVertical,
            // faIcon: faUpDown,
            colorIcon: "#ff9083",
            scale: ICON_SCALE_DEFAULT,
            scaleMobile: ICON_SCALE_MOBILE,
        },
        toy: {
            nameProp: "toy",
            value: "toy",
            label: "Toy o mini",
            longLabel: "Toy o mini",
            perro: {info: "Menos de 5Kg"},
            gato: {info: "Menos de 2Kg"},
            // faIcon: faMars,
            // colorIcon: "#ff9083",
            // scale: ICON_SCALE_DEFAULT,
            // scaleMobile: ICON_SCALE_MOBILE,
        },
        pequeno: {
            nameProp: "pequeno",
            value: "pequeno",
            label: "Pequeño",
            longLabel: "pequeño",
            perro: {info: "Menos de 13Kg y ±45cm a la cruz"},
            gato: {info: "De 2 a 3Kg"},
            // faIcon: faMars,
            // colorIcon: "#ff9083",
            // scale: ICON_SCALE_DEFAULT,
            // scaleMobile: ICON_SCALE_MOBILE,
        },
        mediano: {
            nameProp: "mediano",
            value: "mediano",
            label: "Mediano",
            longLabel: "Mediano",
            perro: {info: "De 15Kg a 25Kg y de 45 a 55cm a la cruz"},
            gato: {info: "De 3 a 5Kg"},

            // faIcon: faMars,
            // colorIcon: "#ff9083",
            // scale: ICON_SCALE_DEFAULT,
            // scaleMobile: ICON_SCALE_MOBILE,
        },

        grande: {
            nameProp: "grande",
            value: "grande",
            label: "Grande",
            longLabel: "Grande",
            perro: {info: "De 25Kg a 50Kg y más de 55cm a la cruz"},
            gato: {info: "Más de 7Kg"},
            // faIcon: faMars,
            // colorIcon: "#ff9083",
            // scale: ICON_SCALE_DEFAULT,
            // scaleMobile: ICON_SCALE_MOBILE,
        },

        gigante: {
            nameProp: "gigante",
            value: "gigante",
            label: "Gigante",
            longLabel: "Gigante",
            perro: {info: "Más de 50Kg y más de 55cm a la cruz"},
            gato: {info: "Más de 15 años"},
            // faIcon: faMars,
            // colorIcon: "#ff9083",
            // scale: ICON_SCALE_DEFAULT,
            // scaleMobile: ICON_SCALE_MOBILE,
        },
    },
    estado: {
        "default": {
            nameProp: "default",
            label: "En adopción",
            longLabel: "En adopción",
            value: "en-adopcion",
            faIcon: faHeart,
            // faIcon: faRulerVertical,
            // faIcon: faUpDown,
            colorIcon: "#ff9083",
            scale: ICON_SCALE_DEFAULT,
            scaleMobile: ICON_SCALE_MOBILE,
        },
        "en-adopcion": {
            nameProp: "en-adopcion",
            value: "en-adopcion",
            label: "En adopción",
            longLabel: "En adopción",
            // faIcon: faMars,
            // colorIcon: "#ff9083",
            // scale: ICON_SCALE_DEFAULT,
            // scaleMobile: ICON_SCALE_MOBILE,
        },
        urgente: {
            nameProp: "urgente",
            value: "urgente",
            label: "Urgente",
            longLabel: "Urgente",
            // faIcon: faMars,
            // colorIcon: "#ff9083",
            // scale: ICON_SCALE_DEFAULT,
            // scaleMobile: ICON_SCALE_MOBILE,
        },
        adoptado: {
            nameProp: "adoptado",
            value: "adoptado",
            label: "Adoptado",
            longLabel: "Adoptado",
            // faIcon: faMars,
            // colorIcon: "#ff9083",
            // scale: ICON_SCALE_DEFAULT,
            // scaleMobile: ICON_SCALE_MOBILE,
        },
        acogido: {
            nameProp: "acogido",
            value: "acogido",
            label: "Acogido",
            longLabel: "Acogido",
            // faIcon: faMars,
            // colorIcon: "#ff9083",
            // scale: ICON_SCALE_DEFAULT,
            // scaleMobile: ICON_SCALE_MOBILE,
        },
        sacrificado: {
            nameProp: "sacrificado",
            value: "sacrificado",
            label: "Sacrificado",
            longLabel: "Sacrificado",
            // faIcon: faMars,
            // colorIcon: "#ff9083",
            // scale: ICON_SCALE_DEFAULT,
            // scaleMobile: ICON_SCALE_MOBILE,
        },
        "cuarentena": {
            nameProp: "cuarentena",
            value: "cuarentena",
            label: "En cuarentena",
            longLabel: "En cuarentena",
            // faIcon: faMars,
            // colorIcon: "#ff9083",
            // scale: ICON_SCALE_DEFAULT,
            // scaleMobile: ICON_SCALE_MOBILE,
        },
    },
    color: {
        "default": {
            nameProp: "default",
            label: "TODOS",
            longLabel: "Todos",
            value: [],
            maxLimit: 4,
            faIcon: faPalette,
            colorIcon: "#000",
            scale: ICON_SCALE_DEFAULT,
            scaleMobile: ICON_SCALE_MOBILE,
        },
        blanco: {
            nameProp: "blanco",
            label: "Blanco",
            longLabel: "Blanco",
            value: "blanco",
            colorIcon: "#fff",
        },
        negro: {
            nameProp: "negro",
            label: "Negro",
            longLabel: "Negro",
            value: "negro",
            colorIcon: "#ff9083",
        },
        marron: {
            nameProp: "marron",
            label: "Marrón",
            longLabel: "Marrón",
            value: "marron",
            colorIcon: "#ff9083",
        },
        "marron-claro": {
            nameProp: "marron-claro",
            label: "Marrón claro",
            longLabel: "Marrón claro",
            value: "marron-claro",
            colorIcon: "#ff9083",
        },
        gris: {
            nameProp: "gris",
            label: "Gris",
            longLabel: "Gris",
            value: "gris",
            colorIcon: "#ff9083",
        },
        beige: {
            nameProp: "negro",
            label: "Negro",
            longLabel: "Negro",
            value: "negro",
            colorIcon: "#ff9083",
        },
        atigrado: {
            nameProp: "atigrado",
            label: "Atigrado",
            longLabel: "Atigrado",
            value: "atigrado",
            colorIcon: "#ff9083",
        },
        azul: {
            nameProp: "azul",
            label: "Azul",
            longLabel: "Azul",
            value: "azul",
            colorIcon: "#ff9083",
        },
        leonado: {
            nameProp: "leonado",
            label: "Leonado",
            longLabel: "Leonado",
            value: "leonado",
            colorIcon: "#ff9083",
        },

    },
    caracter: {
        "default": {
            nameProp: "default",
            label: "TODOS",
            longLabel: "Todos",
            value: [],
            faIcon: faShieldDog,
            maxLimit: 5,
            colorIcon: "#000",
            scale: ICON_SCALE_DEFAULT,
            scaleMobile: ICON_SCALE_MOBILE,
        },
        "bueno-con-perros": {
            nameProp: "bueno-con-perros",
            label: "Bueno con perros",
            longLabel: "Bueno con perros",
            value: "bueno-con-perros",
        },
        "bueno-con-gatos": {
            nameProp: "bueno-con-gatos",
            label: "Bueno con gatos",
            longLabel: "Bueno con gatos",
            value: "bueno-con-gatos",
        },
        "bueno-con-ninos": {
            nameProp: "bueno-con-ninos",
            label: "Bueno con niños",
            longLabel: "Bueno con niños",
            value: "bueno-con-ninos",
        },
        "bueno-con-personas": {
            nameProp: "bueno-con-personas",
            label: "Bueno con personas",
            longLabel: "Bueno con personas",
            value: "bueno-con-personas",
        },
        "bueno-con-otros-animales": {
            nameProp: "bueno-con-otros-animales",
            label: "Bueno con otros animales",
            longLabel: "Bueno con otros animales",
            value: "bueno-con-otros-animales",
        },
        "bueno-en-casa": {
            nameProp: "bueno-en-casa",
            label: "Bueno en casa",
            longLabel: "Bueno en casa",
            value: "bueno-en-casa",
        },
        "bueno-en-el-coche": {
            nameProp: "bueno-en-el-coche",
            label: "Bueno en el coche",
            longLabel: "Bueno en el coche",
            value: "bueno-en-el-coche",
        },
        "buen-temperamento": {
            nameProp: "buen-temperamento",
            label: "Buen temperamento",
            longLabel: "Buen temperamento",
            value: "buen-temperamento",
        },
    },
    vacunas: {
        "default": {
            nameProp: "default",
            value: false,
            label: "No vacunado",
            longLabel: "No vacunado",
            faIcon: faSyringe,
        },
        true: {
            nameProp: "true",
            value: true,
            label: "Vacunado",
            longLabel: "Vacunado",
        }
    },


    /** Retorna el label de la prop_value indicados
     *  prop=sexo value=hembra -> Hembra
     * @param prop {String}
     * @param value {String}
     * @returns {String}
     */
    convertValue: function (prop, value) {
        return this[prop][value]?.label;
    },
    /** Retorna el value de la prop_label indicados
     *  prop=sexo value=Hembra -> hembra
     * @param prop {String}
     * @param label {String}
     * @returns {String}
     */
    revertLabel: function (prop, label) {
        return Object.keys(this[prop]).find(key => this[prop][key]?.label === label);
    },
    /** Retorna el objecto config de la prop_subProp
     * prop=sexo value=hembra -> {CONFIG_SEXO_HEMBRA}
     * @param prop {String}
     * @param subprop {String}
     * @returns {{}}
     */
    getProp: function (prop, subprop) {
        if (subprop) return this[prop][subprop]
        return this[prop]
    },
}

export const ICONS = {
    locationDot: {
        faIcon: faLocationDot,
        colorIcon: "#000",
    },
    protectora: {
        value: "protectora",
        label: "Protectora",
        longLabel: "Protectora de animales",
        faIcon: faHouse,
        colorIcon: "#ff9083",
        scale: ICON_SCALE_DEFAULT,
        scaleMobile: ICON_SCALE_MOBILE,
    },
    particular: {
        value: "protectora",
        label: "Particular",
        longLabel: "Particular",
        faIcon: faUser,
        colorIcon: "#ff9083",
        scale: ICON_SCALE_DEFAULT,
        scaleMobile: ICON_SCALE_MOBILE,
    },
    search: {
        faIcon: faMagnifyingGlass,
        colorIcon: "#000",
    },
    clicks: {
        faIcon: faEye,
        colorIcon: "#000",
    },
    check: {
        faIcon: faCheck,
        colorIcon: "#000",
    },
    xmarck: {
        faIcon: faXmark,
        colorIcon: "#000",
    },
    heart: {
        faIcon: faHeart,
        colorIcon: "#000",
    },
    filterButton: {
        faIcon: faFilter,
        colorIcon: "#88888880",
    }
}

// console.log("▼▼▼  AnimalFrontEndConfig  ▼▼▼")
// console.log({
//     PROCESS_ENV_NODE_ENV: process.env.NODE_ENV,
//     PROCESS_ENV_DEV_ENV: process.env.DEV_ENV,
// })
